import { render, staticRenderFns } from "./MetadataOriginLabel.vue?vue&type=template&id=26215441&scoped=true&"
import script from "./MetadataOriginLabel.vue?vue&type=script&lang=js&"
export * from "./MetadataOriginLabel.vue?vue&type=script&lang=js&"
import style0 from "./MetadataOriginLabel.vue?vue&type=style&index=0&id=26215441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26215441",
  null
  
)

export default component.exports